import { FC, ReactNode } from "react";

import { HStack, Text, VStack } from "@/components/ui";
import { useLocalization } from "@/hooks";

interface QuestionFieldProps {
  children: ReactNode;
  /** Optional question number displayed to the left of the input row. */
  order?: number;
}

/**
 * Standard question-prompt field: renders the "Your question *" label and the
 * optional order prefix, then lays out its children horizontally to the right
 * of the prefix. Children typically include the `QuestionTextInput` and any
 * inline controls (e.g. a compact media picker trigger).
 */
const QuestionField: FC<QuestionFieldProps> = ({ children, order }) => {
  const { i18n } = useLocalization();
  return (
    <VStack className="gap-2">
      <HStack className="items-center gap-1">
        <Text className="text-sm font-semibold text-typography-800">
          {i18n.t("questions.yourQuestion")}
        </Text>
        <Text className="text-sm font-semibold text-error-500">*</Text>
      </HStack>
      <HStack className="items-start gap-3">
        {order !== undefined && (
          <Text className="pt-2 text-sm font-bold text-typography-900">
            {order}.
          </Text>
        )}
        {children}
      </HStack>
    </VStack>
  );
};

export default QuestionField;
